import {
  DatabaseRowDataFunctions_getRowDataWithMaxCountsForDatabase,
  DatabasesDefaultDirections,
  DatabasesDefaultSortField,
  DatabasesDisplayGridRowData,
  DatabasesExplorerQueryGrid_QueryResultListNode,
  DatabasesExplorerQueryGrid_QueryResults,
  DatabasesExplorerQueryGrid_QueryVariables,
  DatabasesExplorerQueryGrid_selectConnectionListResult,
  DatabasesQueryGql,
  GraphQLGlobalTypes,
  PartialQueryVariables,
} from '@tableau/data-catalog-client-components';
import { defaultMemoize } from 'reselect';
import { catalogApolloClient } from '../CatalogApolloClient';
import { BaseGraphQLResourceQuery } from './BaseGraphQLResourceQuery';
import { getSearchFilter } from './CatalogFilterClauseHelpers';
import { getSortOrderOrDefault } from './CatalogOrderClauseHelpers';
import { makeSliceableFactoryForGraphQLQuery } from './GraphQLSliceable';


const getSliceableFactorySingleton = defaultMemoize(() => {
  return makeSliceableFactoryForGraphQLQuery<
    DatabasesExplorerQueryGrid_QueryResultListNode,
    DatabasesDisplayGridRowData,
    DatabasesExplorerQueryGrid_QueryVariables,
    DatabasesExplorerQueryGrid_QueryResults
    >(
    {
      queryGql: DatabasesQueryGql,
      selectConnectionListResult: DatabasesExplorerQueryGrid_selectConnectionListResult,
      mapResultNode: DatabaseRowDataFunctions_getRowDataWithMaxCountsForDatabase,
    },
    catalogApolloClient
  );
});

export class DatabasesGraphQLResourceQuery
  extends BaseGraphQLResourceQuery<DatabasesExplorerQueryGrid_QueryVariables, DatabasesDisplayGridRowData> {

  public constructor() {
    super(getSliceableFactorySingleton());
  }

  protected getPartialQueryVariables(): PartialQueryVariables<DatabasesExplorerQueryGrid_QueryVariables> {
    const textSearch = getSearchFilter(this.getFilters());
    const orderBy = getSortOrderOrDefault(this.getOrder(), DatabasesDefaultSortField, DatabasesDefaultDirections);
    return { textSearch, orderBy: orderBy as GraphQLGlobalTypes.DatabaseSortOrder };
  }
}
